//document.addEventListener("DOMContentLoaded", function () {});
//let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

// GLOBAL: add padding to first element after header 
let h = document.querySelector("#header");
let hH = h.offsetHeight;
let hNext = h.nextElementSibling;
let hNextP = parseInt(window.getComputedStyle(hNext, null).getPropertyValue('padding-top'));
hNext.style.cssText += 'padding-top:' + (hNextP + hH) + 'px;';



// GLOBAL: grab query vars from URL
const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

// if agent_code is present > 
// always add to hrefs (home, order) to be passed to next page 
// ignore hrefs with '#'
function add_agent_code(ac) {
  let links = document.getElementsByTagName('a');
  for (let i = 0; i < links.length; i++) {
    //console.log(links[i]);
    links[i].href.indexOf('#') == -1 ?
      links[i].href += links[i].href.indexOf('?') == -1 ? '?agent_code=' + ac :
        links[i].href.indexOf('agent_code') == -1 ? '&agent_code=' + ac : '' : '';
  }
}
params.agent_code ? add_agent_code(params.agent_code) : '';




// HOME >> (Welcome Section): click event listeners 
let welcome_section = !!document.querySelector("#welcome_section");
// if #welcome-buckets exists we're on the home page  
if (welcome_section) {
  document.addEventListener('click', function (e) {
    if (e.target.closest('.welcome-bucket')) {
      e.preventDefault();
      let scrollTo;
      e.target.tagName.toLowerCase() === 'div' ?
        scrollTo = e.target.querySelector('a').getAttribute('href') :
        scrollTo = e.target.getAttribute('href');
      document.querySelector(scrollTo).scrollIntoView({
        behavior: 'smooth'
      });
    }
    // console.log(event.target);
  }, false);
}



// ORDER PAGE: 
let order_page = !!document.querySelector("#order_page");
function update_service_type(st) {
  service_type = st;
  //console.log(service_type);
  let ye = document.querySelectorAll('.yearly-price, .savings');
  let btns = document.querySelectorAll('.sign-up-btn');
  let order_opts = document.querySelector('#order_opts');
  service_type != 'Yearly' ? order_opts.classList.replace('Yearly', 'Monthly') : order_opts.classList.replace('Monthly', 'Yearly');
  for (let i = 0; i < ye.length; ++i) {
    service_type != 'Yearly' ? ye[i].classList.add('d-none') : ye[i].classList.remove('d-none');
  }
  for (let j = 0; j < btns.length; ++j) {
    let link = btns[j].getAttribute('href');
    let newlink = service_type != 'Yearly' ? link.replace('Yearly', 'Monthly') : link.replace('Monthly', 'Yearly');
    btns[j].setAttribute('href', newlink);
    //console.log(newlink);
  }
}
// if #order_page exists we're on the order page  
/*
if (order_page) {
  let service_type = document.querySelector('input[name="service_type"]:checked').value;
  //console.log(service_type);
  document.addEventListener('click', function (e) {
    if (e.target.matches('#ymtoggle .btn')) {
      service_type = e.target.textContent;
      update_service_type(service_type);
    }
  });
  update_service_type(service_type);
}
*/



// CHECKOUT PAGE: 
let checkout_page = !!document.querySelector("#checkout_page");
// if #checkout_page exists we're on the checkout page  
if (checkout_page) {
  // add agent_code to #agent_code input 
  params.agent_code ? document.getElementById('agent_code').value = params.agent_code : '';
  let products = document.querySelectorAll('.product');
  let product, product_price, product_multiplier, product_quantity_check, product_total, all_products_valid, order_total, order_complete;
  let price_displays = document.querySelectorAll('.price-display');
  let total_due = document.querySelectorAll('.total-due');
  let terms_check = document.querySelector('#terms_check');
  let order_btn = document.querySelector('#order_btn');

  // hidden (calc) inputs 
  //let calc_service_type = document.getElementById('calc_service_type');
  //let calc_service_fee = document.getElementById('calc_service_fee');
  //let calc_setup_fee = document.getElementById('calc_setup_fee');
  //let calc_quantity = document.getElementById('calc_quantity');
  //let calc_total_due = document.getElementById('calc_total_due');

  /*
  products.forEach((product) => {

    product_price = parseFloat(product.querySelector('.price').innerText);
    //const selectedRadio = product.querySelector('input[name="nnumber_of_server_protection"]:checked');
    //const multiplier = selectedRadio ? parseInt(selectedRadio.getAttribute('data-multiplier')) : 0;
    product_multiplier = 0;

    product_total = parseFloat(product.querySelector('.product-total').innerText);

  });
  */

  document.addEventListener('click', function (e) {
    if (e.target.matches('.quantity-check')) {
      e.preventDefault();
      product = e.target.closest('.product');
      product_total = product.querySelector('.product-total');
      product_quantity_check = e.target.previousElementSibling;
      //console.log(product_quantity_check.checked);
      order_total = 0;
      //
      if (product_quantity_check.checked) {
        //console.log('running: product_quantity_check.checked');
        product.querySelector('.is-total').classList.replace('d-inline-flex', 'd-none');
        product.querySelector('.no-total').classList.replace('d-none', 'd-inline-flex');
        product_total.textContent = '';
        order_complete = false;
        order_btn.disabled = true;
        // clear hidden input field
        product.querySelector('input[type="hidden"]').value = '';
      } else {
        //console.log('running > else: product_quantity_check.checked');
        product_multiplier = parseInt(e.target.previousElementSibling.getAttribute('data-multiplier'));
        product_price = parseFloat(product.querySelector('.price').innerText);
        product_total.textContent = parseInt(product_price * product_multiplier).toLocaleString('en-US');
        product.querySelector('.is-total').classList.replace('d-none', 'd-inline-flex');
        product.querySelector('.no-total').classList.replace('d-inline-flex', 'd-none');
        //
        product.querySelector('input[type="hidden"]').value = product_multiplier;
      }
      product_quantity_check.checked ? product_quantity_check.checked = false : product_quantity_check.checked = true;
      //
      order_complete = true;
      all_products_valid = true;
      products.forEach((product) => {
        product_total = parseFloat(product.querySelector('.product-total').innerText.replace(',', ''));
        isNaN(product_total) ? all_products_valid = false : order_total += product_total;
      });
      all_products_valid ? order_complete = true : order_complete = false;
      //
      if (order_complete) {
        price_displays.forEach(function (pd) {
          pd.querySelector('.is-total').classList.replace('d-none', 'd-inline-flex');
          pd.querySelector('.no-total').classList.replace('d-inline-flex', 'd-none');
          pd.querySelector('.total-due').textContent = order_total.toLocaleString('en-US');
        });
      } else {
        price_displays.forEach(function (pd) {
          pd.querySelector('.is-total').classList.replace('d-inline-flex', 'd-none');
          pd.querySelector('.no-total').classList.replace('d-none', 'd-inline-flex');
        });
      }
      
      
    } else if (e.target.id == 'terms_check') {
      terms_check.checked ? order_complete ? order_btn.disabled = false : order_btn.disabled = true : order_btn.disabled = true;
    }
  });

  // form validation 
  let order_form = document.querySelector('#order_form');
  //let valid_fields, nvalid_fields;
  order_form.addEventListener('submit', function (e) {
    if (!order_form.checkValidity()) {
      e.preventDefault();
      e.stopPropagation();
      //valid_fields = document.querySelectorAll(':valid');
      let invalid_fields = order_form.querySelectorAll(':invalid:not(form):not(fieldset)');
      let scrollTo;
      //console.log("valid_fields: " + valid_fields);
      //console.log("invalid_fields: " + invalid_fields);
      /*for (let i = 0; i < invalid_fields.length; i++) {
        console.log(invalid_fields[i]);
      }*/
      //console.log(invalid_fields[0].id);
      scrollTo = '#' + invalid_fields[0].id;
      document.querySelector(scrollTo).scrollIntoView({
        behavior: 'smooth'
      });
    }
    order_form.classList.add('was-validated');
  }, false);

} // eof CHECKOUT PAGE 




// GLOBAL: reveal body << last 
document.body.classList.remove("init");